const actionTypes = {
    GET_TABLE_RECORDS_SUCCESS: 'GET_TABLE_RECORDS_SUCCESS',
    CLEAN_API_LOGGERS: 'CLEAN_API_LOGGERS',
    ADD_API_LOGGERS: 'ADD_API_LOGGERS',
    DATA_DASHBOARD: 'DATA_DASHBOARD'
};

export default actionTypes;